export default __webpack_public_path__ + "static/media/click.edb068e7.png";